module.exports = __webpack_public_path__ + "web-assets/media/video.0f23dbf1.mp4";